<template>
    <div>
        firma tanımlama sayfası
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>